import { Accordion, HyperLink } from '@doist/marketist'

import { Interpolate } from 'components'
import { ContainerSidebar } from 'components/container-sidebar/container-sidebar'
import { useTranslation } from 'next-i18next'

import css from './Faq.module.css'

export function FAQ() {
    const { t } = useTranslation('pricing')

    return (
        <ContainerSidebar tag="section" className={css.faqContainer}>
            <ContainerSidebar.Main>
                <Accordion
                    title={t('faq.title')}
                    items={[
                        {
                            question: t('faq.whatHappensToThreads.question'),
                            answer: t('faq.whatHappensToThreads.answer'),
                        },
                        {
                            question: t('faq.downgradeData.question'),
                            answer: t('faq.downgradeData.answer'),
                        },
                        {
                            question: t('faq.whatGuest.question'),
                            answer: (
                                <Interpolate
                                    t={t}
                                    i18nKey="faq.whatGuest.answer"
                                    mapping={{
                                        link: (
                                            <HyperLink
                                                size="body-sm"
                                                href="https://twist.com/help/articles/115004169449"
                                            />
                                        ),
                                    }}
                                />
                            ),
                        },
                        {
                            question: t('faq.guestCost.question'),
                            answer: t('faq.guestCost.answer'),
                        },
                        {
                            question: t('faq.userBilled.question'),
                            answer: t('faq.userBilled.answer'),
                        },
                        {
                            question: t('faq.mixUsers.question'),
                            answer: (
                                <Interpolate
                                    t={t}
                                    i18nKey="faq.mixUsers.answer"
                                    mapping={{
                                        link: (
                                            <HyperLink
                                                size="body-sm"
                                                href="https://twist.com/help/articles/115003654289"
                                            />
                                        ),
                                        linkswitch: (
                                            <HyperLink
                                                size="body-sm"
                                                href="https://twist.com/help/articles/115003731105"
                                            />
                                        ),
                                        linkbilling: (
                                            <HyperLink
                                                size="body-sm"
                                                href="https://twist.com/help/articles/115003679665"
                                            />
                                        ),
                                    }}
                                />
                            ),
                        },
                        {
                            question: t('faq.enterprisePricing.question'),
                            answer: (
                                <Interpolate
                                    t={t}
                                    i18nKey="faq.enterprisePricing.answer"
                                    mapping={{
                                        link: (
                                            <HyperLink
                                                size="body-sm"
                                                href="mailto:support@twist.com&subject=Enterprise%20Customer%20Onboarding%20Request"
                                            />
                                        ),
                                    }}
                                />
                            ),
                        },
                    ]}
                />
            </ContainerSidebar.Main>
        </ContainerSidebar>
    )
}
